// Validate newsletter
const signUpNewsletterBtn = document.querySelectorAll('.signup-form__button');
signUpNewsletterBtn.forEach(button => validateNewsletter(button));

function validateNewsletter(btn) {
   const emailField = btn.parentElement.parentElement.querySelector('.signup-form__email');
   const emailCheckbox = btn.parentElement.parentElement.querySelector('.signup-form__checkbox');
   btn.addEventListener('click', (e) => {
      if(!emailField.value.length || emailCheckbox.checked === false){
         e.preventDefault();

         alert(theme.strings.cart_terms_confirmation);
      }
   })
}
